import React from 'react'

const SvgHome = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1645 443"
  >
    <defs>
      <style>
        {
          "\n      .cls-1, .cls-27, .cls-42, .cls-45 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #eae2f0;\n      }\n\n      .cls-11, .cls-12, .cls-28, .cls-3, .cls-38, .cls-42, .cls-44 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #061a47;\n      }\n\n      .cls-5 {\n        fill: #e8a18e;\n      }\n\n      .cls-6 {\n        fill: #9757a3;\n      }\n\n      .cls-7 {\n        fill: #13a89e;\n      }\n\n      .cls-8 {\n        fill: url(#SVGID_4_);\n      }\n\n      .cls-9 {\n        fill: #a02410;\n      }\n\n      .cls-10 {\n        fill: #dba795;\n      }\n\n      .cls-11, .cls-12, .cls-51 {\n        fill: #9e695c;\n      }\n\n      .cls-11, .cls-28, .cls-42 {\n        opacity: 0.2;\n      }\n\n      .cls-12 {\n        opacity: 0.5;\n      }\n\n      .cls-13 {\n        fill: #02594f;\n      }\n\n      .cls-14 {\n        fill: #f4e2ca;\n      }\n\n      .cls-15 {\n        fill: #f15931;\n      }\n\n      .cls-16 {\n        opacity: 0.15;\n      }\n\n      .cls-17 {\n        fill: #281a24;\n      }\n\n      .cls-18 {\n        fill: #f9f5ec;\n      }\n\n      .cls-19 {\n        fill: #052620;\n      }\n\n      .cls-20 {\n        fill: #ad6b55;\n      }\n\n      .cls-21 {\n        fill: #382632;\n      }\n\n      .cls-22 {\n        fill: #fff;\n      }\n\n      .cls-23 {\n        fill: #0f192d;\n      }\n\n      .cls-24 {\n        fill: #9f5d4a;\n      }\n\n      .cls-25 {\n        fill: #894e46;\n      }\n\n      .cls-26 {\n        fill: #121d3b;\n      }\n\n      .cls-27 {\n        stroke: #bdb5c6;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-28 {\n        fill: #dd8172;\n      }\n\n      .cls-29 {\n        fill: #824237;\n      }\n\n      .cls-30 {\n        fill: #8f493b;\n      }\n\n      .cls-31 {\n        fill: #844339;\n      }\n\n      .cls-32 {\n        fill: #dbc3a1;\n      }\n\n      .cls-33 {\n        fill: #d69b6d;\n      }\n\n      .cls-34 {\n        fill: #e8d1b5;\n      }\n\n      .cls-35 {\n        fill: #e8ceaf;\n      }\n\n      .cls-36 {\n        fill: #513715;\n      }\n\n      .cls-37 {\n        fill: #097263;\n      }\n\n      .cls-38 {\n        fill: #e68770;\n      }\n\n      .cls-38, .cls-44 {\n        opacity: 0.3;\n      }\n\n      .cls-39 {\n        fill: #a32b28;\n      }\n\n      .cls-40 {\n        fill: #2e2122;\n      }\n\n      .cls-41 {\n        fill: #26211d;\n      }\n\n      .cls-42 {\n        stroke: #9e695c;\n      }\n\n      .cls-42, .cls-45 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-43 {\n        fill: #713a39;\n      }\n\n      .cls-44 {\n        fill: #9e6352;\n      }\n\n      .cls-45 {\n        stroke: #0a285e;\n        stroke-width: 2px;\n      }\n\n      .cls-46 {\n        fill: #564444;\n      }\n\n      .cls-47 {\n        fill: #19bcac;\n      }\n\n      .cls-48 {\n        fill: #c4432d;\n      }\n\n      .cls-49 {\n        fill: #f9faec;\n      }\n\n      .cls-50 {\n        fill: #b56fc6;\n      }\n\n      .cls-51 {\n        opacity: 0.2;\n        mix-blend-mode: multiply;\n      }\n    "
        }
      </style>
      <pattern
        id="SVGID_4_"
        data-name="SVGID 4 "
        width={131}
        height={104}
        patternTransform="matrix(1.31, 0, 0, -1.31, 3903.52, -19050.07)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect className="cls-1" width={131} height={104} />
        <g>
          <rect className="cls-1" width={131} height={104} />
          <g>
            <rect className="cls-1" width={131} height={104} />
            <rect className="cls-1" width={131} height={104} />
            <rect className="cls-2" width={131} height={104} />
          </g>
        </g>
      </pattern>
    </defs>
    <g className="cls-3">
      <g id="Layer_1" data-name="Layer 1">
        <path
          className="cls-4"
          d="M1359.2,442.4c.4-13.2.7-25.5.1-35.9-2.1-41,10.6-70.6-17.2-118.6l-28.7-42.8L1247,224.4c-53.4,46.2-50.5,83-53.1,133.1-1.2,23.4-3.9,53-5.1,84.9Z"
        />
        <path
          className="cls-5"
          d="M929.3,312.2c.5-2.4,22.9-25.2,23.2-27.7,6.7-47-6-98.6-6-98.6l72.5-1,10.3,69.9.2,1.6c47.6,41.8,74.3,109.5,45.3,119-14.9,4.9-25.7,2.2-62.9-18.1l-73-16.6Z"
        />
        <path
          className="cls-6"
          d="M1095,442.4c-1.5-21.4-3.1-41.1-3.6-57.6-2.4-84-50.1-117.9-50.1-117.9-59.2,31.8-99.3,31.3-99.3,31.3-6.7,4-15.8,17.8-15.8,17.8-27,41.4-36.5,81.6-40.8,126.4Z"
        />
        <path
          className="cls-7"
          d="M483.5,442.5c-1.7-93.6-19.9-159.8-41.6-193.2,0,0-35.7-14.3-57.4-4.5-10.2,4.6-44.5,27.6-44.5,27.6-18.8,21.3-23.5,38.2-28.9,59-7.6,29.4-9.1,91.3-9.1,111.1H483.5Z"
        />
        <path
          className="cls-8"
          d="M778,442.5c-.2-5-.4-10.2-.4-15.5,0-17.8-1.7-65.2-9.7-91.7-5.7-18.8-10.7-34-30.4-53.2,0,0-36-20.7-46.7-24.9-22.7-8.9-60.2,4.1-60.2,4.1-24.6,29.2-43.3,92.6-43.8,181.2Z"
        />
        <path
          className="cls-9"
          d="M149.3,244.7s-33-7.7-41,3.1c-22.9,30.8,91.5,133.1,91.5,133.1C199,330.3,170.5,258.5,149.3,244.7Z"
        />
        <path
          className="cls-10"
          d="M96.2,239.2c9.8,4.1,51.5,20,53.1,5.5L147.5,164l-63.3,2.6s.3,5,.4,13.8c.1,13.8-5.6,29.1-10.8,45.1C73.2,227.1,94.6,238.5,96.2,239.2Z"
        />
        <path
          className="cls-11"
          d="M148.6,212.5l-.3-11.3s-37.8-4.9-48.8-19.9C99.6,181.3,105.5,206.4,148.6,212.5Z"
        />
        <path
          className="cls-10"
          d="M86,166.5s14.5-.7,18.5-13.9c.1-.2,18-72.4,43.5-72.7,30.2-.3,43.1,8.9,46.2,38.5,1.3,12.5,7.4,17.4,13.3,23.5,2.3,2.4.1,7-3.5,6.4l-4.4-.1a1.86,1.86,0,0,0-1.9,1.7c-1.3,16.8-9.1,40.1-14.4,44.2-3.3,2.6-15.9,6.4-27.7,7.1C110.5,204,86,166.5,86,166.5Z"
        />
        <path
          className="cls-4"
          d="M66.5,60.3c12.2-17.1,33.3-24.7,60.4-21.8,0,0,29.6,5,40.8,5.2.3,0,8.8,36.2,8.8,36.2A67.69,67.69,0,0,0,157.3,92c-7.8,7-13,22.2-13.9,29.9-.3,2.6-.4,6.2-.5,8.6v.5c-6.7,10.4-11.6.5-11.8.5v-4.1c-.1-.1,0-.3-.1-.4s-12.2,5.1-13.2,12.4c-2.8,21.8-20.5,42.4-31.5,42.4-24.1,0-22-34.5-32.9-62.8C44.9,96.3,54.4,77.3,66.5,60.3Z"
        />
        <path
          className="cls-10"
          d="M107.1,132.2a11.68,11.68,0,0,0,13.5,9.6h.2a12.44,12.44,0,0,0,10.5-13.4c-.4-7-5.9-12.5-12.1-12C107.8,117.3,106,125.6,107.1,132.2Z"
        />
        <path
          className="cls-12"
          d="M116.8,129.9a3.28,3.28,0,0,1,3.6-2.5,8.38,8.38,0,0,0-2.5-3.1.54.54,0,1,1,.6-.9,8.46,8.46,0,0,1,3.1,3.9,9.9,9.9,0,0,1,.3,5.4c-.1.7-1.2.4-1-.3a10.24,10.24,0,0,0-.1-3.9h-1a.6.6,0,0,0-.4.1l-.2.1h-.1l-.3.2-.1.1h0c-.1.1-.2.1-.2.2h0l-.1.1c-.1.1-.1.2-.2.3h0v.1c0,.1-.1.2-.1.3v.8h0v.2c0,.1.1.2.1.3l.1.1v.1l.2.3.1.1h0l.1.1a.48.48,0,0,1,0,.7h0a.61.61,0,0,1-.8,0A3.36,3.36,0,0,1,116.8,129.9Z"
        />
        <path
          className="cls-13"
          d="M185.8,79c8.9-5.7,14.2-14.6,12.9-26.4-.9-7.5-1.8-18.3-12.9-21.1-4.5-1.2-21.8-17.4-35.4-15.2-12.2,1.9-19.4,9.9-32.5,13C97.7,34.1,87.7,40.9,87,48.3s3.4,13.6-1.7,22.9C79.4,82,73.9,83.7,71.6,92.2c-1.2,4.6,1.8,5.1,7.6,20.5,4.3,11.6,1.6,19.7,5.5,21.5,7.8,3.6,12.6-7.1,19.7-8.6,9.2-1.9,16.6-6.7,17.3-7.7,5.1-7.2-3.5-15.4.9-19.8,4.8-5,15.9,4.5,31.9.4,9.9-2.5,22.2-2.3,24.9-4.7C188.3,85.9,180.1,82.6,185.8,79Z"
        />
        <path
          className="cls-14"
          d="M143,129.6l26.6-1.6a20.78,20.78,0,0,0,0,6.1c1.3,9.1,8.2,15.7,15.4,14.7,6.7-.9,11.3-8.1,10.9-16.5l2.8-.4c-.4-1-1.2-2-1.6-2.8l-1.6.2c-1.7-8.6-8.3-14.6-15.2-13.6-4.7.7-8.4,4.4-10,9.5l-27.1,1.6Zm28.9,4.1c-1.1-7.5,2.9-14.3,8.8-15.1s11.6,4.6,12.7,12.1-2.9,14.3-8.8,15.1-11.6-4.6-12.7-12.1Z"
        />
        <path
          className="cls-15"
          d="M19.6,443.5c.8-80.6,2.4-35.8,7.4-121,2.5-41.5,2.3-92.9,52.3-112.4,0,0,59.8,45.9,77.3,84.9,19.4,43.4,42.4,63.7,47.8,108,7.8,63.5-2.4-23.9,4.2,40.5"
        />
        <g className="cls-16">
          <path
            className="cls-17"
            d="M160.9,258.9c-4.2,6-10.1,11.3-17.8,11.5a1.16,1.16,0,0,1-1.1-1.3,1.27,1.27,0,0,1,1.1-1.1c6.8-.1,12.1-5,15.8-10.3C159.7,256.4,161.8,257.6,160.9,258.9Z"
          />
        </g>
        <path
          className="cls-18"
          d="M121.6,326.2a225.76,225.76,0,0,1-43,7.8,203.16,203.16,0,0,1-22.1.7c-6.3-.1-14,.5-19.9-2-1.7-.7-.9-3.4.8-2.7,5.9,2.4,13.6,1.8,19.9,1.9,7.1.1,14.2-.1,21.3-.7a223.89,223.89,0,0,0,42.2-7.7,1.33,1.33,0,0,1,1.7,1,1.25,1.25,0,0,1-.9,1.7Z"
        />
        <path
          className="cls-18"
          d="M127.2,396.9c-14.3,4.6-30.5,5.3-45.4,5.7A271.43,271.43,0,0,1,35,399.4c-1.8-.3-1-3,.8-2.7a253.42,253.42,0,0,0,46.1,3.1c14.7-.3,30.6-1,44.7-5.6,1.6-.6,2.3,2.1.6,2.7Z"
        />
        <path
          className="cls-18"
          d="M204.1,418.4c-11.6,3.5-23.2,6.7-35.2,8.4-12.5,1.8-25,2.4-37.6,2.9-1.7.1-1.7-2.7,0-2.8,12.1-.5,24.2-1.1,36.2-2.7,12.2-1.7,24-4.9,35.9-8.5a1.27,1.27,0,0,1,1.6,1,1.25,1.25,0,0,1-.9,1.7Z"
        />
        <path
          className="cls-18"
          d="M34.5,433.8c-4.9.2-9.9.2-14.9,0-1.8-.1-1.8-2.9,0-2.8,5,.2,9.9.2,14.9,0C36.3,430.9,36.3,433.7,34.5,433.8Z"
        />
        <path
          className="cls-18"
          d="M185.6,352.1a207.39,207.39,0,0,1-59.7,12.7c-1.7.1-1.7-2.7,0-2.8a203.35,203.35,0,0,0,59-12.6c1.6-.6,2.3,2.1.7,2.7Z"
        />
        <path
          className="cls-18"
          d="M33.4,371.6a44.8,44.8,0,0,1-9.7-.6,1.37,1.37,0,0,1-1-1.7h0a1.45,1.45,0,0,1,1.7-1,38.88,38.88,0,0,0,9,.5,1.37,1.37,0,0,1,1.4,1.4h0a1.37,1.37,0,0,1-1.4,1.4Z"
        />
        <path
          className="cls-18"
          d="M144.9,278.1a123.73,123.73,0,0,1-12.6,12.5,60,60,0,0,1-13.6,9.8c-1.3.6-1.8-2.1-.5-2.7,4.7-2.2,9-5.8,13.1-9.5a114.87,114.87,0,0,0,12.2-12c1-1.2,2.4.8,1.4,1.9Z"
        />
        <path
          className="cls-18"
          d="M43,277.9A37.17,37.17,0,0,1,30.2,276a1.39,1.39,0,0,1,.7-2.7,35,35,0,0,0,12,1.8,1.4,1.4,0,0,1,.1,2.8Z"
        />
        <g className="cls-16">
          <path
            className="cls-17"
            d="M162.7,262a29.16,29.16,0,0,1-18.2,10.6,1.22,1.22,0,0,1-1.5-.9,1.24,1.24,0,0,1,.8-1.5,27,27,0,0,0,17.1-10,1.15,1.15,0,0,1,1.7,0,1.19,1.19,0,0,1,.1,1.8Z"
          />
        </g>
        <path
          className="cls-19"
          d="M184.6,108.3c.6-1.4-.2-1.9-2.9-1.9a27.64,27.64,0,0,0-8.1,1.5c-5.3,1.9-7.5,5.8-6.1,4.9,2.4-1.4,4.5-2.3,10-3.5C180.5,108.8,184.2,109.2,184.6,108.3Z"
        />
        <path
          className="cls-20"
          d="M1456.5,374c5.1-19.8,13.1-109.5,40.4-135.2,0,0,14.8.9,24.5-3.5a168.4,168.4,0,0,0,34.5-20.8c31.2,11.2,41.4,36.5,44.3,44,6.7,17.2,15.1,92.7,20.8,184.5l-162.5-8"
        />
        <path
          className="cls-20"
          d="M1496.9,238.8c-23,22.4-34.8,43.8-45.5,66.1-6.1,12.7-8.8,27.5-9.5,38.1-1.2,17,3.6,16,3.6,16s4.5-15.6,24-41.5c16.2-21.7,40-54.9,58-71.2Z"
        />
        <path
          className="cls-20"
          d="M1483.9,261.9c-.1-5.2,13-23.1,13-23.1,5.2-39.6-4.5-83.6-4.5-83.6l55.4-.8,8,60.2c-3.1,9.7-16.8,21.9-28.4,31.7C1506.8,263.6,1484.2,274.8,1483.9,261.9Z"
        />
        <path
          className="cls-11"
          d="M1497.4,189.5l.5,6.1c26.9.1,37.5-33,37.5-33C1526.1,164.6,1497.4,189.5,1497.4,189.5Z"
        />
        <path
          className="cls-20"
          d="M1547.1,135.8a23.81,23.81,0,0,0-3-1.8c-2.6-.9,1-4.9,1-7.6-.6-34.5-23.2-59.4-50.3-61.8-17.2-1.5-29.6-2-37,6.8-6.2,7.3-8.7,22.4-9.1,36.3-.4,12.9-6.4,18.4-12.2,25.1-2.3,2.6.4,7.2,4.3,6.3l4.7-.5a2.07,2.07,0,0,1,2.2,1.6,91.75,91.75,0,0,0,7.3,24.6c7.5,15.3,20.4,24.7,41.8,24.7,28.1,0,44.3-29.3,50.2-38.2A133.45,133.45,0,0,0,1547.1,135.8Z"
        />
        <path
          className="cls-21"
          d="M178.7,133.5a7.07,7.07,0,0,1,8.1-2.4c.6.2,1-.7.4-.9a8,8,0,0,0-9.3,2.7C177.5,133.3,178.3,134,178.7,133.5Z"
        />
        <path
          className="cls-22"
          d="M191.4,162.2a5.67,5.67,0,0,1-.8,1.3,12.25,12.25,0,0,1-.8,1.2c-.3.4-.7,1-.7,1-9.9-.3-11.1-9-9.6-7.9A26.44,26.44,0,0,0,191.4,162.2Z"
        />
        <path
          className="cls-23"
          d="M788.7,189.8c3.8-6.2,5.7-13.1,8.6-19.8a26.19,26.19,0,0,0-1.4-23.3c-3.6-6.1-9.8-10.7-12.2-17.3-3.8-10.2,1.9-22.3-2.9-32a378.09,378.09,0,0,0-40.6,104c-.9,4-1.3,9.1,2.1,11.3l-.3-.8c6.5-1.3,14.9,13,21.4,14.2,12.4,2.4,5.5,13.7,20.2,13.8C780.2,233.1,781.7,201.4,788.7,189.8Z"
        />
        <path
          className="cls-24"
          d="M737.6,286.6c-.4-2.2-19.4-23.5-19.7-25.8C712.2,217,723,169,723,169l-61.3-.9L653,233.2l-.2,1.5c-40.2,38.9-62.8,101.9-38.3,110.8,12.7,4.6,21.8,2,53.2-16.8l61.8-15.4Z"
        />
        <path
          className="cls-11"
          d="M717.5,206.4l-.5,6.2c-29.8.1-41.6-35.3-41.6-35.3C685.7,179.5,717.5,206.4,717.5,206.4Z"
        />
        <path
          className="cls-24"
          d="M667.2,147.6c0-.2,2.2-7.3,2.2-10.3C670,99.1,694,71.5,722.9,69c18.2-1.6,31.4-2.2,39.3,7.5,6.6,8.1,9.3,24.8,9.7,40.2.4,14.3,6.8,20.4,13,27.8,2.4,2.9-.5,8-4.5,6.9l-5-.6a2.18,2.18,0,0,0-2.3,1.8c-1.6,10-4.1,19.3-7.8,27.2-8,16.9-18,32.1-44.5,27.4-29.4-5.3-47.1-32.4-53.4-42.3A142.91,142.91,0,0,1,667.2,147.6Z"
        />
        <path
          className="cls-25"
          d="M667.2,328.6a46.55,46.55,0,0,0-16.4-8.8c-6.3-2-13.2-2.9-19.6-1a.82.82,0,0,1-1-.7,1,1,0,0,1,.5-1c6.7-2,14-1,20.5,1a50.87,50.87,0,0,1,17.1,9.3c1,.7-.2,1.9-1.1,1.2Z"
        />
        <path
          className="cls-8"
          d="M732.6,279.8s-72.7-.9-98.2-24.2c0,0-26.3,23.6-32,74.4l8.3,17.5,38.6,3,52.1-13.1,42.5-20,2.5-24.3C746.5,293,732.4,279.7,732.6,279.8Z"
        />
        <path
          className="cls-26"
          d="M761.7,115.9c.9-2.2.2-3.1-3.2-3.8a23.83,23.83,0,0,0-10.3.8c-6.9,2-12.5,8.3-10.5,7.3a39,39,0,0,1,14.8-4.8C756.3,114.9,761.5,116.4,761.7,115.9Z"
        />
        <path
          className="cls-26"
          d="M794.7,88.4c-.6-11.8-4.5-23.7-12.8-32-4.7-4.7-10.5-8-16.3-11.3L745.8,34c-4.9-2.7-9.8-5.5-15.3-6.6-6.6-1.3-14.4.4-17.8,6.2-6.9-6.6-16.9-9.4-26.5-9.1s-18.8,3.6-27.4,7.7c-11.2,5.5-22.2,13.4-26.3,25.2-1.8,5.2-2.1,11-4.5,16-6.4,13.8-26,19-29.4,33.8a22.77,22.77,0,0,0-.5,5.8c-.3,5.7,1.7,11.5,3.2,17.1a47.9,47.9,0,0,1,1.6,9.2,16.35,16.35,0,0,1-2.7,8.9c-2.1,3.1-5.4,5.2-8,7.9,0,0-15.1,23.9,18.2,28.9s15.1-6.3,52.5,10.7c-1.8-2.6,0-6.1.7-8.2,1.5-4.4,4.3-8.5,4.4-13.2v-2.2c.1-7.3-6.3-12.7-11.9-17.5s-10.8-9.8-13.3-16.5a21,21,0,0,1-1.4-6.5,16,16,0,0,1,4.9-11.1c5.4-4.8,13.4-4.6,20.5-5.7,10-1.6,19.9-6.9,24.8-15.8,3.4-6.2,4.1-13.6,7.1-20.1,7-15.2,27.6-22.2,42.4-14.4,0,0,30.2,17,33.2,39l.5,6.7,4-2.7a74.4,74.4,0,0,1,3.3,12.3c9.6-4.9,12.9-16.9,12.7-27.8C794.8,90.9,794.8,89.6,794.7,88.4Z"
        />
        <path
          className="cls-26"
          d="M757,70c-12.1-2.9-28.6,4.7-37.2,13.1a24.31,24.31,0,0,0-7.5,15.6c-.6,8,3.8,16.8.2,24.5-3.4,7.4-11.7,10.9-18.5,14.5-6.2,3.4-12.3,7.2-16,13.5a20.06,20.06,0,0,0-3,8.9,37.08,37.08,0,0,0,.3,4.7c.2,3.5-.8,4.7-2.3,7.5a72.16,72.16,0,0,0-7.7,23.5l5.8-1.5-34.5-41.8c-2.4-2.9-5.3-5.9-6.5-9.5-1.4-4.5.7-9.4,2.2-13.6A144.79,144.79,0,0,1,643,106.9a258.1,258.1,0,0,1,28.5-38.8c5.2-6,10.8-11.1,18.8-12.9,8.6-1.9,18-1.5,26.7-1.6,4.8,0,9.5,0,14.3.2,4.2.1,9.4-.3,12.8,2.6,5.1,4.2,5.7,12.6,10,17.7,2.9,3.4,7.8-1.5,4.9-4.9-4.5-5.2-4.8-12.8-10-17.7-5.9-5.4-15.1-4.6-22.5-4.7-17.5-.3-39.2-2.6-53.4,9.7-6.6,5.7-12.1,13.1-17.5,19.9A241.25,241.25,0,0,0,640,98.3a162.34,162.34,0,0,0-12.3,23.8c-3.2,7.6-7.2,16.6-3.8,24.7,1.7,4,4.8,7.4,7.6,10.8l11.3,13.7L666,199.4c1.6,1.9,5.4,1,5.8-1.5a66.77,66.77,0,0,1,7.4-22.6c1.4-2.6,3.2-5.1,3.2-8.1.1-3.4-1.2-6.1.1-9.6,4.9-13.5,23.8-15.5,32.6-25.9a22.87,22.87,0,0,0,5.5-16.2c-.3-6.8-3.1-14-.5-20.7,2.3-5.7,7.5-9.6,12.8-12.4,6.2-3.3,14.9-7.2,22-5.5,4.6.9,6.5-5.8,2.1-6.9Z"
        />
        <path
          className="cls-26"
          d="M753.6,73.4c-4.6-1.5-9.6-.1-14.2,1.4-11.4,3.8-23.9,10.5-25.9,22.3-1.4,8.1,2.8,16.6.8,24.6-1.7,6.5-7.2,11.2-12.9,14.7s-12,5.9-17.2,10.2-9.2,10.8-8,17.4a15.44,15.44,0,0,1,.5,3.1c0,1.7-1,3.3-1.9,4.8a69.66,69.66,0,0,0-8.7,25l-36.4-44.1c-2.5-3-5.1-6.3-5.9-10.1-.7-3.6.3-7.3,1.5-10.8,8-24.1,23.2-45.1,39.6-64.4,4.4-5.2,9.1-10.4,15.2-13.3,5.9-2.8,12.6-3.3,19.1-3.6,10.8-.5,21.6-.5,32.4-.2,4,.1,8.2.4,11.5,2.7,5.9,4.2,6.1,13.2,11,18.4"
        />
        <path
          className="cls-27"
          d="M612.8,372.5s1.2,31.9,6.2,46.8a6.91,6.91,0,0,0,6.9,4.7c10-.6,35.5-3.5,75.9-17.8a6,6,0,0,0,4-6.7c-1.9-11.5-7.3-39.8-16.9-50.6"
        />
        <path
          className="cls-28"
          d="M1021.2,203.8c-13.1,17.8-39.1,39.3-67.1,24.2l-1.9-13.7,66-30.7Z"
        />
        <polygon
          className="cls-5"
          points="931.8 88.5 1003.3 67.1 1042.9 128.3 1032.1 152.9 991.3 174.5 966.3 170.3 940.4 113.1 931.8 88.5"
        />
        <path
          className="cls-5"
          d="M1038.8,176.4s-15.7,1.1-21.7-12.6c-.1-.2-28.5-75.7-56-72.8-32.5,3.5-45.2,15.1-44.9,47.3.2,13.6-5.7,19.6-11.3,26.9-2.2,2.9.8,7.6,4.6,6.4l4.7-.7a2,2,0,0,1,2.3,1.6c3.6,17.9,14.9,42,21.1,45.8,3.9,2.4,17.9,4.8,30.7,4.1C1017,219.9,1038.8,176.4,1038.8,176.4Z"
        />
        <path
          className="cls-29"
          d="M923.2,134.4c-.7-2.5.5-3.5,4.4-3.8a27.27,27.27,0,0,1,11.3,2c7.2,3,10,10,8,8.6-3.3-2.3-6.1-3.8-13.8-5.4C928.9,134.8,923.7,136,923.2,134.4Z"
        />
        <g>
          <path
            className="cls-30"
            d="M1077.2,146.3c3.2-1.4,4.2-4.9,3.8-8.4a19.83,19.83,0,0,0-5.2-11c3.9-6.7,7.9-16.6-.5-20,4.2-2.6,4.4-8.2,2.9-13.2-.7-2.4-6.6-3.4-8.8-3.8,4.2-3.4,8.1-7.6,7.5-13.4-.2-2.2-2.6-4.7-2.4-6.5.1-1.2,1.4-2.7,1.6-4a10.8,10.8,0,0,0-.2-4c-2.6-13.6-20.2-16.2-30-9a10.42,10.42,0,0,0-6.8-9c-4.4-1.6-8.9,0-12.6,2.5a11,11,0,0,0-4.1-13c-5.5-3.7-12.4-1.7-17.1,2.2.5-6.6-7.1-11-13.2-11.5a20.8,20.8,0,0,0-12.8,3.4c-1.7,1.1-2.9,2.7-4.5,4-2.2,1.8-1.7,1.2-4.4-.1a18.08,18.08,0,0,0-13.1-1.2,17.08,17.08,0,0,0-5.7,2.9c-1.4,1.1-2.6,3.5-4,4.3-1.6.9-3.1-1.3-5.1-2.2a10.84,10.84,0,0,0-5-.9,11.94,11.94,0,0,0-9,5.5c-1.2-2.2-3.2-4.4-5.9-4.1a7.08,7.08,0,0,0-3.6,1.7,5.13,5.13,0,0,0-1.5,2.3c-6,1.2-12.7,2.8-16.2,8.3-2.2,3.5-1.9,7.9,1.4,10.2-5.6,2.9-10.3,8-10,14.7.1,3.7,2.5,7.8,5.9,8.3-3.7,3.3-5,8.6-4.2,13.6.9,5.7,5.4,8.3,10.2,6a9.77,9.77,0,0,0,7.5,11.7,9.44,9.44,0,0,0,6.2-.7c3.1,8.5,18,7.9,23.3,1.2a9.25,9.25,0,0,0,5.3-1.9,8.28,8.28,0,0,0,8.1,8.5,9,9,0,0,0,4.2-1c-1,6.4,4.6,15.2,11.3,12.9-1.1,5.7-.1,11.4,6,13.8,1.7.6,9.2,2.1,12.3,1,.9,2.6,4.3,5.9,5.2,6.9,2.4,2.7,6.2,7.4,6.2,7.4,1.4,2.5,3.5,4.7,6.2,5.1-1.3,3.8.3,8.5,4.7,9.2a6.19,6.19,0,0,0,4-.8c-.5,4.7,2.9,10.4,7.6,10.4-5.2,9.1,6.1,22.9,12.1,19.1a11.69,11.69,0,0,0,10.3,5.1c4.7-.4,6.5-4.4,7.7-6.9,1.4,1.7,5.8,1.8,7.7.5a8.89,8.89,0,0,0,3-10.9c5.8,3.4,13.5-7.1,9.6-12.2,7-1.1,9.8-11.7,3.9-15.9C1083.6,161,1082.3,150.4,1077.2,146.3Z"
          />
          <path
            className="cls-31"
            d="M904.2,100.3c-.8-3.1-1.2-6.7.6-9.6a6.31,6.31,0,0,1,6.8-3.1l-.9.8a12.3,12.3,0,0,1,5.8-10.7c3.3-1.9,8.2-1.4,9.2,2.9.2,1-1.3,1.1-1.5.2a3.63,3.63,0,0,0-3.5-2.7,6.67,6.67,0,0,0-4.6,1.8,10.57,10.57,0,0,0-3.8,8.4c0,.4-.4,1-.9.8a5,5,0,0,0-5.6,2.8c-1.2,2.4-.8,5.3-.2,7.8.3,1-1.2,1.6-1.4.6Z"
          />
          <path
            className="cls-31"
            d="M948.2,37a12.25,12.25,0,0,1,8.5,10.6l-1.4-.2c1.4-2.7,4.8-3.2,7.4-2.1a8.19,8.19,0,0,1,4.8,7.6c0,1-1.5,1.1-1.5.2a6.74,6.74,0,0,0-3.5-6.1c-1.9-1-4.8-1.1-6,1.1a.82.82,0,0,1-1,.4.68.68,0,0,1-.4-.6,10.69,10.69,0,0,0-7.2-9.3c-.9-.4-.7-1.9.3-1.6Z"
          />
          <path
            className="cls-31"
            d="M1023,183.8a10.73,10.73,0,0,0,6-4,20.45,20.45,0,0,0,2-3.1c.5-1,1.6-2.7.8-3.7l1.3-.7c1.5,3.2,5.7,3.3,8.3,1.5a9.06,9.06,0,0,0,3.7-8.5.77.77,0,0,1,.7-.8.87.87,0,0,1,.8.6,10.63,10.63,0,0,1-5.2,10.5c-3.4,1.8-7.9,1-9.7-2.7-.4-.8.8-1.4,1.3-.7,1.7,2.3-.9,6-2.3,7.9a13,13,0,0,1-7.2,5.2c-.9.1-1.4-1.3-.5-1.5Z"
          />
          <path
            className="cls-31"
            d="M996.9,102.2a6.36,6.36,0,0,0,11,6.4h0c.5-.7,1.4,0,1.3.6a6.28,6.28,0,0,0,12.2,2.5.76.76,0,0,1,1.4.6,8,8,0,0,1-9.1,4.9,8.18,8.18,0,0,1-6-8.3l1.3.6a7.85,7.85,0,0,1-13.5-8c.5-.7,1.9-.1,1.4.7Z"
          />
          <path
            className="cls-31"
            d="M1046.2,53.5a12.25,12.25,0,0,0-4.5,7.2c-.6,2.8,1.2,5.2,3.2,7a.91.91,0,0,1,.1,1.1,2.19,2.19,0,0,1-.5.3c-2.8.1-5.6,1.8-6,4.8a4.46,4.46,0,0,0,3.7,5.2,2.85,2.85,0,0,0,1.3,0,.76.76,0,0,1,.2,1.5,5.91,5.91,0,0,1-6.6-5.3v-1a7.34,7.34,0,0,1,7.4-6.8c-.1.4-.3.9-.4,1.3-2.3-2-4.2-4.7-3.8-8a13.65,13.65,0,0,1,5.2-8.6.81.81,0,0,1,1.1.2,1.37,1.37,0,0,1-.4,1.1Z"
          />
          <path
            className="cls-31"
            d="M988.4,64.2c1.2,3.3,5.1,3.7,8,2.5a10.1,10.1,0,0,0,5.7-6.1.82.82,0,0,1,1-.4c.1.1.2.1.3.2,3.1,4.1,8.3.8,10.8-2.2a.78.78,0,1,1,1.2,1,11.73,11.73,0,0,1-6.5,4.4,6.65,6.65,0,0,1-6.7-2.4l1.3-.1a11.61,11.61,0,0,1-7.8,7.3c-3.5.9-7.4-.2-8.8-3.8a.88.88,0,0,1,.5-1,1.1,1.1,0,0,1,1,.6Z"
          />
          <path
            className="cls-31"
            d="M1055.4,138.3c-.9-3.3-.7-7.1,1.9-9.5a5.8,5.8,0,0,1,8.1-.1l-1.2.3a6.09,6.09,0,0,1,4.2-3.9,10,10,0,0,1,6.8.9.76.76,0,0,1-.6,1.4h0a9,9,0,0,0-5.6-.9,5,5,0,0,0-3.4,3.1.82.82,0,0,1-1,.4c-.1,0-.1-.1-.2-.1a4.32,4.32,0,0,0-6.2.2c0,.1-.1.1-.1.2-1.9,2.1-2,5-1.3,7.6a.73.73,0,0,1-1.4.4Z"
          />
        </g>
        <g>
          <path
            className="cls-5"
            d="M1013.3,150.6c-3.1,6.3-8.3,10.1-14.7,7.1a12.63,12.63,0,0,1-6.5-15.8c2.3-6.6,9-10.2,14.9-8.3C1017.9,137.3,1016.3,144.5,1013.3,150.6Z"
          />
          <path
            className="cls-28"
            d="M1007.2,141.6a.64.64,0,0,0-.8-.6,10.14,10.14,0,0,0-5.1,2.7,13.07,13.07,0,0,0-2.9,5.6c-.2.9,1.2,1.1,1.4.2a12,12,0,0,1,1.8-4h0l.3.1c.2.1.4.1.5.2l.1.1.2.1.4.3h0l.1.1c.1.1.1.2.2.3v.1c0,.1,0,.1.1.2v.8h0v.6h0v.1a.31.31,0,0,1-.1.2.37.37,0,0,0-.1.3l-.1.1v.1c-.1.1-.1.2-.2.3l-.2.2h0l-.1.1-.3.2-.1.1h0a.7.7,0,1,0,.5,1.3,4.18,4.18,0,0,0,2.3-4.8,4.5,4.5,0,0,0-2.3-2.4,9.09,9.09,0,0,1,3.8-1.9A.86.86,0,0,0,1007.2,141.6Z"
          />
        </g>
        <path
          className="cls-11"
          d="M768.7,169.2a18.41,18.41,0,0,1-.9,2.5c-.1.3-.4,1-.6,1.5s-.4,1.1-.4,1.1c-11.7-1.2-13.7-7.5-11.3-6.9A58.31,58.31,0,0,0,768.7,169.2Z"
        />
        <path
          className="cls-26"
          d="M756.7,76s14.7,10,15.2,37.5l7.5-4,4-21.5L770.8,76Z"
        />
        <path
          className="cls-21"
          d="M752.4,134a6.94,6.94,0,0,1,8.4-.8.52.52,0,0,0,.5-.9,7.84,7.84,0,0,0-9.6.9C751.3,133.6,751.9,134.4,752.4,134Z"
        />
        <path
          className="cls-32"
          d="M369.1,194.9c-7.3-11.4-23.7-19.3-36.3-11.8l-1.2.9a5.63,5.63,0,0,0-3.9,4c-2.1,6.9-7.4,11.7-7.9,19.3-.4,6.6,1.3,15.2,4.9,20.8a11.44,11.44,0,0,0,6.7,5.1c4,.9,7.2-1.6,11.1-1.4,8.2.6,14.3,8.9,22.2,2C375.2,224.5,376.4,206.3,369.1,194.9Z"
        />
        <path
          className="cls-33"
          d="M340.1,272.4c.4-2.1,18.5-22.4,18.7-24.6,5.4-41.8-4.8-87.5-4.8-87.5l58.5-.9,8.3,62.1.2,1.4c38.3,37.1,59.9,97.2,36.5,105.6-12,4.3-20.8,2-50.8-16l-58.9-14.7Z"
        />
        <path
          className="cls-11"
          d="M359.2,195.9l.5,5.9c28.4.1,39.6-33.6,39.6-33.6C389.5,170.3,359.2,195.9,359.2,195.9Z"
        />
        <path
          className="cls-33"
          d="M407.1,139.8c0-.2-2-7-2.1-9.9-.5-36.4-23.5-62.7-51-65.1-17.4-1.5-30-2-37.5,7.2-6.3,7.7-8.9,23.6-9.3,38.3-.4,13.7-6.5,19.4-12.4,26.5-2.3,2.8.5,7.6,4.3,6.6l4.7-.5a1.94,1.94,0,0,1,2.2,1.7,97.05,97.05,0,0,0,7.4,25.9c7.6,16.1,17.2,30.6,42.4,26.1,28-5,44.9-30.9,50.9-40.3A101.09,101.09,0,0,0,407.1,139.8Z"
        />
        <path
          className="cls-34"
          d="M318.4,69.8A46,46,0,0,1,346.9,40c1-.3.6-1.9-.4-1.6a47.71,47.71,0,0,0-29.6,30.9.82.82,0,0,0,.7,1A.66.66,0,0,0,318.4,69.8Z"
        />
        <path
          className="cls-18"
          d="M304.1,392.4a526.56,526.56,0,0,0,81.2,6.9.78.78,0,0,0,.7-.9.68.68,0,0,0-.7-.7,520.39,520.39,0,0,1-80.8-6.9C303.5,390.6,303,392.2,304.1,392.4Z"
        />
        <path
          className="cls-18"
          d="M303.2,412.6c12.9,2,25.8,4.4,38.7,6,13.5,1.8,27.3,1.3,40.9,1.3a.78.78,0,0,0,.7-.9.68.68,0,0,0-.7-.7c-13.1-.1-26.4.4-39.5-1.2-13.3-1.6-26.5-4.1-39.7-6.2-1-.1-1.5,1.5-.4,1.7Z"
        />
        <path
          className="cls-18"
          d="M386.3,399.2c21.7,4.8,43.7,9.5,66,8.5,1,0,1-1.7,0-1.6-22.2,1-44-3.6-65.6-8.4-1-.3-1.5,1.3-.4,1.5Z"
        />
        <path
          className="cls-18"
          d="M383.4,419.7c11.2,3.1,22.5,6.1,33.9,8.7,10.8,2.4,21.6,2.2,32.6,1.5,1-.1,1-1.7,0-1.6-11.3.7-22.2.9-33.3-1.7s-21.9-5.4-32.7-8.4a.8.8,0,0,0-1,.6.65.65,0,0,0,.5.9Z"
        />
        <path
          className="cls-18"
          d="M458.8,407a130,130,0,0,0,22.5-1.1c.9-.1.9-1.8,0-1.6a130.52,130.52,0,0,1-22.5,1.1C457.9,405.4,457.9,407,458.8,407Z"
        />
        <path
          className="cls-18"
          d="M456.2,429.5a115.62,115.62,0,0,0,26.3-.6c.9-.1.9-1.8,0-1.6a115.75,115.75,0,0,1-26.3.6C455.2,427.7,455.2,429.4,456.2,429.5Z"
        />
        <path
          className="cls-25"
          d="M407.1,312.4a46.27,46.27,0,0,1,15.6-8.4c6-1.9,12.6-2.8,18.7-1a.82.82,0,0,0,.4-1.6c-6.4-1.9-13.3-1-19.6,1a50.54,50.54,0,0,0-16.3,8.8c-.7.7.5,1.9,1.2,1.2Z"
        />
        <path
          className="cls-7"
          d="M344.8,265.8s69.3-.9,93.6-23.1c0,0,25.4,27.6,30.8,76l-8.3,11.5-36.8,2.9-49.6-12.5L334,301.5l-1.9-19.2C332,282.4,345,265.8,344.8,265.8Z"
        />
        <path
          className="cls-32"
          d="M482.6,187.4c-3.3-5.1-7.6-9.4-9.1-15.5-1.4-5.8-.7-12-.4-17.9.7-12.5-1.7-22.9-5.5-34.7a60.22,60.22,0,0,1-3.1-18.8c0-6.7.6-13.4-.2-20.1-1.2-9.6-5.5-19.3-14-24.6-4-2.5-10.1-2.5-13.4-5.7-1.8-1.8-2.8-4.9-4.1-7.1a38.88,38.88,0,0,0-32.9-18.3c-5.9-.2-11.2,1.3-16.7,3.3-7.3,2.7-13.5,1.5-21,.7-12.4-1.3-25.6,0-35.7,8a35.46,35.46,0,0,0-13.3,25.7,6.47,6.47,0,0,0-.4,2c-.4,10.2,6.6,18.4,15.2,23.1,10.3,5.7,22.9,5.4,33,11.5,3.8,2.3,8.1,6.2,8,11.1-.1,5.2-2.5,9.2.8,14.1,2.5,3.7,7.5,4.1,10,7.2s-1.4,11.3-1.2,15.2c.5,10.9,11.2,15.7,13.9,25.3,1.6,5.7-.4,11.9-1.5,17.6a60.49,60.49,0,0,0-1,18.5c1,9.6,2,24.9,11.4,30.4,7.6,4.5,17.7,1.8,24.5-3,9.4-6.6,14-16.3,26.7-16.1,9.8.2,20.4,2,28.6-4.6C490,207.7,488.2,196.1,482.6,187.4Z"
        />
        <path
          className="cls-35"
          d="M334.6,201.9c-3.1,1.7-2.9,5.7-1.9,8.6.7,1.9,1.7,3.8,1.8,5.8,0,1.6-.5,3.5-2.1,4.2-.9.3-.5,1.8.4,1.4,3.4-1.3,3.6-5.4,2.7-8.4-.6-1.9-1.7-3.8-1.9-5.9-.1-1.7.3-3.5,1.8-4.4.8-.5,0-1.8-.8-1.3Z"
        />
        <path
          className="cls-35"
          d="M348.8,208.6c-1.5,2.6-.8,5.6-.2,8.4.5,2.3.8,5.3-1.2,7-.7.6.3,1.7,1.1,1.1,2-1.7,2.2-4.5,1.9-6.9-.4-2.8-1.8-6-.2-8.7a.78.78,0,0,0-.3-1,1,1,0,0,0-1.1.1Z"
        />
        <path
          className="cls-35"
          d="M341.5,66.1c-.2,5.8,5.4,9.3,10,11.3,3.4,1.5,6.9,2.8,10.4,4.2,3.4,1.2,6.7,2.7,10,4.2,2.9,1.6,5.6,3.7,6.9,6.9s.9,6.7.7,10.1a30.22,30.22,0,0,0,.4,9.5,19.24,19.24,0,0,0,3.4,6.5c3.1,4.1,7.4,7.3,10.3,11.6a12.56,12.56,0,0,1,2.3,6.7c0,3.4-1.5,6.6-1.4,10,.3,5.7,3.3,10.7,6.2,15.3,3.3,5.2,7,10.3,8.4,16.4,3.1,14.2-4.9,29.6,2.1,43.2.5.9,1.7.1,1.3-.8-6.2-12-.1-26.1-1.3-38.8-.6-6.1-3.1-11.4-6.3-16.5s-7-9.9-8.4-15.8a19.09,19.09,0,0,1,.4-9.2,13.65,13.65,0,0,0-.2-8c-1.7-4.6-5.5-7.9-8.8-11.3a32,32,0,0,1-4.9-6.1,16.83,16.83,0,0,1-2.2-8.7c0-6.2,1.7-13-2.7-18.2-2.2-2.7-5.4-4.3-8.6-5.6-3.8-1.6-7.6-3-11.4-4.6-5.4-2.2-15.5-5-15.2-12.4.1-.9-1.4-.9-1.4.1Z"
        />
        <path
          className="cls-35"
          d="M390.8,61.5c7.9,5.9,16.4,12.3,20.8,21.3,2.4,4.9,2.8,10.1,2.7,15.5s-.1,10.9,2.5,15.9c2.2,4.1,5.6,7.4,8.2,11.3a22.49,22.49,0,0,1,3,6,19.19,19.19,0,0,1,.1,8.6,81.29,81.29,0,0,0-1.3,8.4,23.25,23.25,0,0,0,1.1,7.9c1.8,5.5,4.7,10.6,6.6,16a86.92,86.92,0,0,1,3.9,39.2c-.1.9,1.3,1.4,1.5.4a87.67,87.67,0,0,0-2.4-35.3,116.29,116.29,0,0,0-6.2-16.1,35.33,35.33,0,0,1-2.8-8.5,29,29,0,0,1,.6-9.3,31.07,31.07,0,0,0,.9-8.6,17.42,17.42,0,0,0-2-6.6c-2.1-4.1-5.5-7.4-8.1-11.2a23.52,23.52,0,0,1-3.4-6.7,35.49,35.49,0,0,1-.9-9.2c0-5.6.2-11.1-1.9-16.4-4.2-10.4-13.6-17.6-22.3-24-.6-.4-1.4.9-.6,1.4Z"
        />
        <path
          className="cls-35"
          d="M456.3,160.2c-1.2,3.9-.3,7.8,1.1,11.4a117.25,117.25,0,0,1,4.2,11.4,49.6,49.6,0,0,1,.2,24.8.73.73,0,1,0,1.4.4,52.15,52.15,0,0,0,.2-23.9,77.06,77.06,0,0,0-4-11.4c-1.6-3.9-3-8.1-1.8-12.4a.78.78,0,0,0-.6-.9,1.87,1.87,0,0,0-.7.6Z"
        />
        <path
          className="cls-36"
          d="M317.2,109.2c-.8-2.2,0-3,3.2-3.4a25.12,25.12,0,0,1,9.8,1.1c6.5,2.2,11.6,8.4,9.7,7.3a34.78,34.78,0,0,0-14-5.1C322.2,108.5,317.3,109.7,317.2,109.2Z"
        />
        <path
          className="cls-37"
          d="M171.8,64.6a9.74,9.74,0,0,0-8.7,1.7c-2.8,1.9-4.7,4.7-6.6,7.4a25,25,0,0,1-7.2,7.3,21.29,21.29,0,0,1-9.1,3.3c-7,.8-13.9-1.7-20.8-.5a14.52,14.52,0,0,0-12.2,12.3,13.67,13.67,0,0,1-1.8,5.6,19.48,19.48,0,0,1-3.9,4.2,32.89,32.89,0,0,1-10,6c-.6.2-.3,1.2.3,1a33.83,33.83,0,0,0,12.5-8.3,13.33,13.33,0,0,0,2.8-3.9,23.57,23.57,0,0,0,1.2-5.1,13.33,13.33,0,0,1,1.7-4.3,13.75,13.75,0,0,1,7-5.8c6.6-2.4,13.8.1,20.6,0a23.08,23.08,0,0,0,17-7.8c2.6-3,4.4-6.5,7.2-9.2,2.5-2.4,6.2-4.2,9.7-3,.5.2.8-.7.3-.9Z"
        />
        <path
          className="cls-37"
          d="M124.6,71a20.94,20.94,0,0,0-10.5,1.9c-1.7.7-3.3,1.5-4.9,2.3a41.61,41.61,0,0,0-4.2,2.3,9.79,9.79,0,0,0-3.2,3.2,15.67,15.67,0,0,0-1.8,4.2,26.4,26.4,0,0,1-1.7,4.7A11.32,11.32,0,0,1,95.5,93a18.31,18.31,0,0,1-9.2,3.8c-.6.1-.4,1,.3,1a19.81,19.81,0,0,0,8.2-3,13.36,13.36,0,0,0,5.2-6.7c.5-1.6.9-3.2,1.5-4.7a9.26,9.26,0,0,1,2.6-3.9c2.4-2.2,5.7-3.6,8.6-4.9,3.7-1.7,7.7-3.1,11.9-2.6.7.1.7-.9,0-1Z"
        />
        <path
          className="cls-21"
          d="M323.5,125.4a2.43,2.43,0,1,1-2.4-2.8A2.6,2.6,0,0,1,323.5,125.4Z"
        />
        <path
          className="cls-22"
          d="M314.5,156c9.9-.3,11.9-9.9,10.4-8.8a26.44,26.44,0,0,1-11.9,4.4l1.3,4.4Z"
        />
        <polygon
          className="cls-8"
          points="626.1 415.5 632.3 422.8 665.3 417.3 696 407.3 688.7 390.5 626.1 415.5"
        />
        <path
          className="cls-21"
          d="M931.3,153.2a2.36,2.36,0,0,1-3.2,1c-.2-.1-.3-.2-.5-.3a3.5,3.5,0,0,1-.6-4.4,2.36,2.36,0,0,1,3.2-1c.2.1.3.2.5.3A3.61,3.61,0,0,1,931.3,153.2Z"
        />
        <path
          className="cls-38"
          d="M921.8,185c.3.5.9,1.5,1.2,2.1.1.2.4.6.6,1a56.18,56.18,0,0,0,5.8-1.9c2.6-1.1,4.8-3.3,4.8-3.8,0-.3-3.2.9-6.7,1.8A34,34,0,0,1,921.8,185Z"
        />
        <path
          className="cls-39"
          d="M1472.9,109.7a59,59,0,0,0-18.2-2.7c-1.2,0-1.8-2.7-.1-3.1,5.3-1.2,13.5,1.7,16.4,3.1S1476.1,110.6,1472.9,109.7Z"
        />
        <g>
          <path
            className="cls-39"
            d="M1552.2,143.7s-3.9,22,6.2,30.2c0-.3,5.2-11.9,12.5-30.2S1552.2,143.7,1552.2,143.7Z"
          />
          <path
            className="cls-39"
            d="M1556.4,60.6s.7-26.7,23.9-20.1,28.4,24.3,20.1,35.7-38.1,12.8-41.6,1.7S1556.4,60.6,1556.4,60.6Z"
          />
          <g>
            <path
              className="cls-39"
              d="M1468.5,62.5s-4.2,26.8,8,39.5,16.3,32.2,16.3,32.2-5.3-17.7-16.5-27.3-18.9-41-12.7-47.8S1468.5,62.5,1468.5,62.5Z"
            />
            <g>
              <path
                className="cls-9"
                d="M1539.4,104.9s2.3,86-4.4,115.1c.6-1.1,7.8,0,7.8,0s14.8-60.8,13.5-78.4c2.4,2.3,4,15.3,6.3,21.6s19.7-5.2,19.7-5.2,15.7-99-35.6-118.2-71.8,8.5-71.8,8.5Z"
              />
              <path
                className="cls-9"
                d="M1464.4,67.4c.6,1.1,12.5,32.4,39.1,32.4s29.4,22.2,42.9,17.2,5.5-29.3-8.3-47-18.3-38.4-43.1-34.3S1456.1,52.4,1464.4,67.4Z"
              />
              <path
                className="cls-39"
                d="M1450.5,99s1.1-29.1,17.6-33.1c20.8-5,20.3-21.3,4.8-22.8S1434.3,66.1,1450.5,99Z"
              />
            </g>
          </g>
        </g>
        <path
          className="cls-40"
          d="M1460.9,123.3a2.7,2.7,0,0,1-3.8.3l-.3-.3a3.37,3.37,0,0,1,.1-4.5,2.7,2.7,0,0,1,3.8-.3l.3.3A3.37,3.37,0,0,1,1460.9,123.3Z"
        />
        <path
          className="cls-22"
          d="M1450,150.1a22.68,22.68,0,0,0,.6,2.5c.1.3.2.8.3,1.2a3.22,3.22,0,0,0,.2.6c8.2.1,14.6-8.6,12.7-7.4A24,24,0,0,1,1450,150.1Z"
        />
        <path
          className="cls-41"
          d="M1572.2,222.7s-39.7,52.9-44.7,92.6c0,0-50.2,14.6-76.1-10.4,0,0-27.9,33.5-6.4,58.3,0,0,17,52.1,4.6,79.8h135s-6.7-79.8-11-98c0,0-53.3-5.9,6.9-115.9Z"
        />
        <path
          className="cls-20"
          d="M1580.4,229.1s57.9,29.9,47.5,214h-43.4l-12.3-110.2"
        />
        <path className="cls-42" d="M1492.8,262.2s1.5-13.7,34.7-18.7" />
        <line className="cls-42" x1={1566} y1={317.5} x2={1573.5} y2={345} />
        <ellipse
          className="cls-43"
          cx={1330.54}
          cy={170.18}
          rx={33.8}
          ry={24.3}
          transform="translate(519.98 1238.96) rotate(-60.11)"
        />
        <path
          className="cls-43"
          d="M1215.6,106.9c4.9-10.2,5.2-21.8,8.2-32.6,5.4-19.2,18-36.8,36.6-43.5a44.94,44.94,0,0,1,28.3-1,40.57,40.57,0,0,1,6.5,2.7c2.4,1.2,4.7,2.9,7.5,2.3,2.1-.4,4.1-1.4,6.2-2a31,31,0,0,1,6.8-1,38.77,38.77,0,0,1,24.2,7.4c7.6,5.6,12.4,13.4,15,22.6,2.9,10.3,3.2,21.5,7.8,31.2a116.3,116.3,0,0,1,8.6,25.1c2.2,9,1.8,14.7-2.1,23.3-1.8,3.8-5.6,6.3-8,9.8s-3.3,7-4.5,11c-1,3.8-2.8,7.7-6.9,8.6a2.88,2.88,0,0,1-3.5-2.2,1.48,1.48,0,0,1-.1-.7c-.6-7.9,2.8-15,4.7-22.3a24,24,0,0,0,.7-11.3c-.8-4.3-1.4-8.6-2-12.9-1.1-7.8-2.2-16.2-6.6-22.9-3.2-4.9-8.4-9.3-14.3-9.6a5.71,5.71,0,0,1-5.7-1.3c-8.4-4.2-18.4-8.3-27.1-3.4a16.71,16.71,0,0,0-6.1,6l.1.3s-2.2,26.9-10.2,39a12.07,12.07,0,0,1-11.4,5.4l-1.9-.2,4.4-2s6.1-2.7,11.2-19.6c-1.8,5.4-4.3,10.7-8.7,14.2-9.1,7.2-17.9-2.7-27.4-2.2-8.3.4-11.5,9-9.8,18,1,5.4.1,8.6,2.7,13.3,2.1,3.8,5.2,8.9,2.8,13.3-2.3,4.2-7.9,4.2-11.8,2.9-4.4-1.5-8-4.9-10.9-8.5-6.2-7.9-12.4-17.9-13.5-28.2C1204.7,124.9,1211.1,116.1,1215.6,106.9Z"
        />
        <ellipse
          className="cls-43"
          cx={1239.36}
          cy={168.99}
          rx={18.6}
          ry={28.9}
          transform="translate(-7.31 270.93) rotate(-12.44)"
        />
        <path
          className="cls-5"
          d="M1258.2,171.1c2.9,1.2,5.7,2.2,8.9,1.1,5.2-1.9,9.8-6.8,13.5-11.9a109.73,109.73,0,0,0,7.5-12.8l22.8,3.5-.4,81.4,3,12.9c-11,15.9-40.8,6.2-49.9,1-1.5-.9-18.1-11.4-17.6-13.6C1250.4,213.9,1257.2,176.4,1258.2,171.1Z"
        />
        <path
          className="cls-44"
          d="M1310.5,210l.4-13.1s-38.8-1.5-53.7-20.5C1257.1,176.4,1261.1,197.7,1310.5,210Z"
        />
        <path
          className="cls-5"
          d="M1258.3,178.4c7.9,9.6,22.7,22,43.4,20.7,22.2-1.4,45.1-24.1,50.9-56a2.19,2.19,0,0,1,2.3-1.9l5.3.2c4.4.7,7.1-4.5,4.2-7.2-7.2-6.9-14.4-12.4-16-26.5-2.8-24.7-13.7-46.3-32.8-55.8a51.92,51.92,0,0,0-6.6,3.5l-.3-6.7-64.2,27-3.2,48.6c1.3,19.6,6.4,34.3,10.7,43.4h0c2.6,5.4,1.1,3.5,4.2,7.8"
        />
        <g>
          <path
            className="cls-5"
            d="M1230,130.4c.1,6.9,3.3,12.6,10.1,12.9a11.34,11.34,0,0,0,12.2-10.5v-.1c.6-6.8-3.8-12.9-9.9-14C1231.4,116.8,1229.9,123.8,1230,130.4Z"
          />
          <path
            className="cls-44"
            d="M1239.1,125.4a.75.75,0,0,1,1-.2h0a11.09,11.09,0,0,1,3.4,4.6,12.64,12.64,0,0,1,.3,6.1c-.2.9-1.5.4-1.4-.5a10.38,10.38,0,0,0,0-4.3h-1.3c-.2,0-.3.1-.5.1h0l-.2.1c-.1.1-.2.1-.3.2h0l-.1.1-.1.1h-.1c0,.1-.1.1-.2.2l-.1.1h0c0,.1-.1.2-.1.3a.35.35,0,0,1-.1.2h0v.8a.37.37,0,0,0,.1.3c0,.1.1.2.1.3h0l.1.1.2.3.1.1h0a.71.71,0,1,1-.9,1.1.1.1,0,0,1-.1-.1,4.2,4.2,0,0,1-.9-1.9,3.59,3.59,0,0,1,.8-3.3,3.63,3.63,0,0,1,3-.9,9.66,9.66,0,0,0-2.6-3.4C1239.1,126.1,1239,125.8,1239.1,125.4Z"
          />
        </g>
        <path
          className="cls-22"
          d="M1335.2,158.4c4.2.7,7.1-.6,8.2-1.8a.45.45,0,0,0,0-.5c-.1,0-.1-.1-.2-.1s-4.6-.4-7.5-1-7.4-1.6-7.4-1.6c-.3,0-.4,0-.3.3C1328.6,155.2,1330.7,157.6,1335.2,158.4Z"
        />
        <path className="cls-45" d="M1292.5,328s8,52,7,67" />
        <ellipse className="cls-46" cx={1336.2} cy={122.7} rx={2.3} ry={4.3} />
        <path
          className="cls-43"
          d="M1339.3,107.7c1.1-1.5.2-2.2-3.3-2.8a35.62,35.62,0,0,0-10.8.4c-7.2,1.3-11.1,5.5-9,4.8,3.5-1.2,6.4-1.9,13.7-2.3C1334,107.5,1338.6,108.7,1339.3,107.7Z"
        />
        <path className="cls-45" d="M1220.5,334s2,61,10,69" />
        <path
          className="cls-43"
          d="M1334.4,68.1S1314.5,53,1300.5,72c0,0-7.1,52.1-20.5,57.5,0,0,13.8-18.7,9.2-30.6,0,0-9.7,17.8-47.6,20.1l-9.5-18.3,6-32.6,39.6-19.5,42.6-8.1,17.4,12.6Z"
        />
        <path
          className="cls-24"
          d="M703.6,442.5c-4.5-20.7-7.6-35.2-7.6-35.2l-63.7,15.5,5.8,19.7Z"
        />
        <path
          className="cls-47"
          d="M379.4,442.5a256.32,256.32,0,0,0,6.2-44.5c1-20,1.2-40.4,14.8-56.9.6-.7-.5-1.8-1.1-1-9.6,11.6-13,25.3-14.3,39.9-1.8,20.5-2.3,40.6-6.8,60.9l-.3,1.6Z"
        />
        <path
          className="cls-47"
          d="M450.3,443h1.5a381.36,381.36,0,0,0,5.4-38.4c2-21.5,6.6-42.9,1-64.3a.82.82,0,0,0-1.6.4c5.7,21.7.8,43.7-1.3,65.6C454.2,418.5,452.6,430.9,450.3,443Z"
        />
        <path
          className="cls-47"
          d="M379.7,440.7h0a32,32,0,0,1,9.7,1.8h4.4a34.4,34.4,0,0,0-14.1-3.4A.8.8,0,1,0,379.7,440.7Z"
        />
        <path
          className="cls-48"
          d="M34.5,444H37c-1-19.5-1.5-39-1.7-58.5-.4-30.7.7-61.5,9-91.2v-.1a1.23,1.23,0,0,0-.8-1.4,1.16,1.16,0,0,0-1.5.8c-8.2,29.4-9.5,59.7-9.1,90C33,403.7,33.5,423.9,34.5,444Z"
        />
        <path
          className="cls-49"
          d="M86.3,443.6h2.8Q82.65,400.7,76,357.8c-5.4-35-11.4-70.7-2.3-105.7a1.39,1.39,0,0,0-2.7-.7c-8.7,33.5-3.7,67.8,1.4,101.5Q79.45,398.35,86.3,443.6Z"
        />
        <path
          className="cls-48"
          d="M130.6,441.1l.3,2.4h2.4l-2.1-18c-3.8-34.4-4.3-69.1-8.9-103.4-4-29.8-13.1-59.2-34-81.6h0a1.2,1.2,0,0,0-1.7,1.7c24.3,26,31.9,61.2,35,95.7S126.5,406.8,130.6,441.1Z"
        />
        <path
          className="cls-49"
          d="M171,443.5c-1.5-10.3-3-20.6-4.8-30.9-5-29.7-10.8-59.2-21.7-87.5-10.4-27.3-23.5-53.6-29.8-82.1-.4-1.7-3.1-1-2.7.7,8.1,36.6,27.3,69.8,37.8,105.7,9,30.6,14.2,62.5,18.4,94.1Z"
        />
        <path
          className="cls-50"
          d="M966.5,442.5h1.6c-1.7-25.5-2-51.6,4.9-76,4.4-15.6,12.3-30.7,25.8-40.2,12.6-8.9,28.9-12.2,43.4-6.1,1,.4,1.4-1.2.4-1.6-22.5-9.5-47.3,3.2-60.1,22.3-16.5,24.8-17.6,57.7-16.8,86.5C966,432.4,966.2,437.5,966.5,442.5Z"
        />
        <path
          className="cls-5"
          d="M1306,442.4c-2.6-14.5-5.8-28.9-9.4-43.2a138.38,138.38,0,0,0-35.2,2c-8.5,1.6-19.3,5.4-27.4,8.2,1.2,11.8,2.4,22.8,3.8,33.1H1306Z"
        />
        <path
          className="cls-11"
          d="M766.9,169.2a18.41,18.41,0,0,1-.9,2.5c-.1.3-.4,1-.6,1.5s-.4,1.1-.4,1.1c-11.7-1.2-13.7-7.5-11.3-6.9A50.68,50.68,0,0,0,766.9,169.2Z"
        />
        <path
          className="cls-51"
          d="M766.83,169.21c-.2.69-.63,1.87-.87,2.51-.1.28-.4,1-.56,1.48s-.42,1.07-.42,1.07c-11.67-1.25-13.74-7.52-11.32-6.88A50.84,50.84,0,0,0,766.83,169.21Z"
        />
      </g>
    </g>
  </svg>
  )
}

export default SvgHome